/**
 * Stable id for the in-app primary content region targeted by the skip link and
 * post-navigation focus management.
 */
export const MAIN_CONTENT_LANDMARK_ID = 'main-content' as const;
